// extracted by mini-css-extract-plugin
export default {"dark":"styles_dark__2gcVK","container":"styles_container__B0u-t","back_link":"styles_back_link__3W569","title":"styles_title__a8SEV","appPlay":"styles_appPlay__jIQ7O"};